// Edgy funny messages for transition messages

import type { AccentToStringMap } from '../../types';

export const FUNNY_EDGY: Record<string, AccentToStringMap> = {
  battlingInnerDemons: {
    'en-US': '...and battling inner demons',
    'en-GB': '...and battling inner demons',
    'en-AU': '...and battling inner demons',
    'en-IN': '...and battling inner demons',
    'es-ES': '...y luchando contra los demonios internos',
    'es-US': '...y luchando contra los demonios internos',
  },
  creatingChaos: {
    'en-US': '...and creating chaos',
    'en-GB': '...and creating chaos',
    'en-AU': '...and creating chaos',
    'en-IN': '...and creating chaos',
    'es-ES': '...y creando caos',
    'es-US': '...y creando caos',
  },
  behavingBadly: {
    'en-US': '...and behaving badly',
    'en-GB': '...and behaving badly',
    'en-AU': '...and behaving badly',
    'en-IN': '...and behaving badly',
    'es-ES': '...y portándose mal',
    'es-US': '...y portándose mal',
  },
  feelingFrisky: {
    'en-US': '...and feeling frisky',
    'en-GB': '...and feeling frisky',
    'en-AU': '...and feeling frisky',
    'en-IN': '...and feeling frisky',
    'es-ES': '...y sintiéndose juguetón',
    'es-US': '...y sintiéndose travieso',
  },
  gettingHigh: {
    'en-US': '...and getting high',
    'en-GB': '...and getting high',
    'en-AU': '...and getting high',
    'en-IN': '...and getting high',
    'es-ES': '...y colocándose',
    'es-US': '...y poniéndose pacheco',
  },
  jerkingOff: {
    'en-US': '...and jerking off',
    'en-GB': '...and having a wank',
    'en-AU': '...and having a wank',
    'en-IN': '...and jerking off',
    'es-ES': '...y haciéndose una paja',
    'es-US': '...y jalándosela',
  },
  smugglingGoods: {
    'en-US': '...and smuggling goods',
    'en-GB': '...and smuggling goods',
    'en-AU': '...and smuggling goods',
    'en-IN': '...and smuggling goods',
    'es-ES': '...y contrabandeando mercancías',
    'es-US': '...y contrabandeando mercancías',
  },
  embezzlingMoney: {
    'en-US': '...and embezzling money',
    'en-GB': '...and embezzling money',
    'en-AU': '...and embezzling money',
    'en-IN': '...and embezzling money',
    'es-ES': '...y malversando fondos',
    'es-US': '...y malversando fondos',
  },
  diggingGrave: {
    'en-US': '...and digging a grave',
    'en-GB': '...and digging a grave',
    'en-AU': '...and digging a grave',
    'en-IN': '...and digging a grave',
    'es-ES': '...y cavando una tumba',
    'es-US': '...y cavando una tumba',
  },
  perpetuatingStereotypes: {
    'en-US': '...and perpetuating stereotypes',
    'en-GB': '...and perpetuating stereotypes',
    'en-AU': '...and perpetuating stereotypes',
    'en-IN': '...and perpetuating stereotypes',
    'es-ES': '...y perpetuando estereotipos',
    'es-US': '...y perpetuando estereotipos',
  },
  robbingTourists: {
    'en-US': '...and robbing tourists',
    'en-GB': '...and robbing tourists',
    'en-AU': '...and robbing tourists',
    'en-IN': '...and robbing tourists',
    'es-ES': '...y robando a turistas',
    'es-US': '...y robando a turistas',
  },
  lightingFire: {
    'en-US': '...and lighting a fire',
    'en-GB': '...and lighting a fire',
    'en-AU': '...and lighting a fire',
    'en-IN': '...and lighting a fire',
    'es-ES': '...y prendiendo fuego',
    'es-US': '...y prendiendo fuego',
  },
  blackmailingFriends: {
    'en-US': '...and blackmailing friends',
    'en-GB': '...and blackmailing mates',
    'en-AU': '...and blackmailing mates',
    'en-IN': '...and blackmailing friends',
    'es-ES': '...y chantajeando a amigos',
    'es-US': '...y chantajeando a amigos',
  },
  fakingDeath: {
    'en-US': '...and faking death',
    'en-GB': '...and faking death',
    'en-AU': '...and faking death',
    'en-IN': '...and faking death',
    'es-ES': '...y fingiendo la muerte',
    'es-US': '...y fingiendo la muerte',
  },
  evadingTaxes: {
    'en-US': '...and evading taxes',
    'en-GB': '...and evading taxes',
    'en-AU': '...and evading taxes',
    'en-IN': '...and evading taxes',
    'es-ES': '...y evadiendo impuestos',
    'es-US': '...y evadiendo impuestos',
  },
  breakingAndEntering: {
    'en-US': '...and breaking and entering',
    'en-GB': '...and breaking and entering',
    'en-AU': '...and breaking and entering',
    'en-IN': '...and breaking and entering',
    'es-ES': '...y allanando moradas',
    'es-US': '...y allanando moradas',
  },
  forgingArtwork: {
    'en-US': '...and forging artwork',
    'en-GB': '...and forging artwork',
    'en-AU': '...and forging artwork',
    'en-IN': '...and forging artwork',
    'es-ES': '...y falsificando obras de arte',
    'es-US': '...y falsificando obras de arte',
  },
  runningPyramidScheme: {
    'en-US': '...and running a pyramid scheme',
    'en-GB': '...and running a pyramid scheme',
    'en-AU': '...and running a pyramid scheme',
    'en-IN': '...and running a pyramid scheme',
    'es-ES': '...y dirigiendo un esquema piramidal',
    'es-US': '...y dirigiendo un esquema piramidal',
  },
  stealingWiFi: {
    'en-US': '...and stealing nearby Wi-Fi',
    'en-GB': '...and stealing nearby Wi-Fi',
    'en-AU': '...and stealing nearby Wi-Fi',
    'en-IN': '...and stealing nearby Wi-Fi',
    'es-ES': '...y robando el Wi-Fi del vecino',
    'es-US': '...y robando el Wi-Fi del vecino',
  },
  initiatingThreesome: {
    'en-US': '...and initiating a threesome',
    'en-GB': '...and initiating a threesome',
    'en-AU': '...and initiating a threesome',
    'en-IN': '...and initiating a threesome',
    'es-ES': '...e iniciando un trío',
    'es-US': '...e iniciando un trío',
  },
  hidingEvidence: {
    'en-US': '...and hiding evidence',
    'en-GB': '...and hiding evidence',
    'en-AU': '...and hiding evidence',
    'en-IN': '...and hiding evidence',
    'es-ES': '...y ocultando pruebas',
    'es-US': '...y escondiendo evidencia',
  },
  unclassifyingDocuments: {
    'en-US': '...and unclassifying documents',
    'en-GB': '...and unclassifying documents',
    'en-AU': '...and unclassifying documents',
    'en-IN': '...and unclassifying documents',
    'es-ES': '...y desclasificando documentos',
    'es-US': '...y desclasificando documentos',
  },
  takingNudes: {
    'en-US': '...and taking nudes',
    'en-GB': '...and taking nudes',
    'en-AU': '...and taking nudes',
    'en-IN': '...and taking nudes',
    'es-ES': '...y sacándose fotos íntimas',
    'es-US': '...y tomando nudes',
  },
  survivingApocalypse: {
    'en-US': '...and surviving the apocalypse',
    'en-GB': '...and surviving the apocalypse',
    'en-AU': '...and surviving the apocalypse',
    'en-IN': '...and surviving the apocalypse',
    'es-ES': '...y sobreviviendo al apocalipsis',
    'es-US': '...y sobreviviendo al apocalipsis',
  },
  raisingHell: {
    'en-US': '...and raising hell',
    'en-GB': '...and raising hell',
    'en-AU': '...and raising hell',
    'en-IN': '...and raising hell',
    'es-ES': '...y armando un escándalo',
    'es-US': '...y armando un desmadre',
  },
  gaslightingTherapist: {
    'en-US': '...and gaslighting my therapist',
    'en-GB': '...and gaslighting my therapist',
    'en-AU': '...and gaslighting my therapist',
    'en-IN': '...and gaslighting my therapist',
    'es-ES': '...y manipulando a mi psicólogo',
    'es-US': '...y gaslighteando a mi terapeuta',
  },
  doomscrolling: {
    'en-US': '...and doomscrolling',
    'en-GB': '...and doomscrolling',
    'en-AU': '...and doomscrolling',
    'en-IN': '...and doomscrolling',
    'es-ES': '...y haciendo doomscrolling',
    'es-US': '...y scrolleando malas noticias',
  },
  startingCult: {
    'en-US': '...and starting a cult',
    'en-GB': '...and starting a cult',
    'en-AU': '...and starting a cult',
    'en-IN': '...and starting a cult',
    'es-ES': '...y fundando una secta',
    'es-US': '...y empezando un culto',
  },
  swipingRedFlags: {
    'en-US': '...and swiping right on red flags',
    'en-GB': '...and swiping right on red flags',
    'en-AU': '...and swiping right on red flags',
    'en-IN': '...and swiping right on red flags',
    'es-ES': '...y deslizando a la derecha en banderas rojas',
    'es-US': '...y swipeando red flags',
  },
  committingMildFelonies: {
    'en-US': '...and committing mild felonies',
    'en-GB': '...and committing minor offences',
    'en-AU': '...and committing minor offences',
    'en-IN': '...and committing mild felonies',
    'es-ES': '...y cometiendo delitos menores',
    'es-US': '...y cometiendo felonías leves',
  },
  catfishingMillionaires: {
    'en-US': '...and catfishing millionaires',
    'en-GB': '...and catfishing millionaires',
    'en-AU': '...and catfishing millionaires',
    'en-IN': '...and catfishing millionaires',
    'es-ES': '...y engañando a millonarios',
    'es-US': '...y catfisheando millonarios',
  },
  sellingFeetPics: {
    'en-US': '...and selling feet pics',
    'en-GB': '...and selling feet pics',
    'en-AU': '...and selling feet pics',
    'en-IN': '...and selling feet pics',
    'es-ES': '...y vendiendo fotos de pies',
    'es-US': '...y vendiendo fotos de patas',
  },
  confessingSins: {
    'en-US': '...and confessing sins',
    'en-GB': '...and confessing sins',
    'en-AU': '...and confessing sins',
    'en-IN': '...and confessing sins',
    'es-ES': '...y confesando pecados',
    'es-US': '...y confesando pecados',
  },
  oppressingChildren: {
    'en-US': '...and oppressing children',
    'en-GB': '...and oppressing children',
    'en-AU': '...and oppressing children',
    'en-IN': '...and oppressing children',
    'es-ES': '...y oprimiendo a los niños',
    'es-US': '...y oprimiendo a los niños',
  },
};
